<app-application-header></app-application-header>
<app-sidenav>
    <app-masquerade-header [topMarginClass]="'-mt-4'"></app-masquerade-header>
    <div
        class="flex-col relative"
        [class.pointer-events-none]="loading$ | async"
    >
        @if (loading$ | async) {
            <app-loading></app-loading>
        }

        <div class="flex">
            <div class="left-content-wrapper">
                <app-application-coordination-navigation-bar></app-application-coordination-navigation-bar>
                <div class="p-4 mt-3">
                    <router-outlet></router-outlet>
                </div>
            </div>
            <div class="right-content-wrapper flex flex-col space-y-3">
                @if (applicationState$ | async) {
                    <app-application-actions
                        [isCoordination]="true"
                    ></app-application-actions>
                }
                <app-navigation-steps></app-navigation-steps>
            </div>
        </div>
        <div class="flex">
            <div class="left-content-wrapper">
                <app-application-footer></app-application-footer>
            </div>
            <div class="right-content-wrapper"></div>
        </div>
    </div>
</app-sidenav>
